import { render, staticRenderFns } from "./crm-reservations.vue?vue&type=template&id=5419c991&scoped=true&"
import script from "./crm-reservations.vue?vue&type=script&lang=js&"
export * from "./crm-reservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419c991",
  null
  
)

export default component.exports